<div class="account-body accountbg"
  [style.background-image]="backgroundImageUrl ? 'url(' + backgroundImageUrl + ')' : ''">
  <img #backgroundTestImage [src]="backgroundImageUrl" height="90" [hidden]="true" alt=""
    (error)="onTestBackgroundImageErrored()">
    @if (appearanceAvailable$ | async) {
      <span id="login-appearance-label" class="visually-hidden">Appearance</span>
      <appearance-toggle class="login-appearance position-absolute top-0 end-0 m-3" labelledBy="login-appearance-label"
        [compact]="true" [preference]="(appearance$ | async) ?? 'light'"
        (preferenceChange)="onAppearanceChosen($event)"></appearance-toggle>
    }
    <!-- Log In page -->
    <div class="container">
      <div class="row vh-100 d-flex justify-content-center align-self-center">

        <div class="col-xl-5 col-lg-6 col-md-8 col-sm-9 mx-auto align-self-center login-card-col">
          <div class="card login-card">
            <div class="card-body p-0 login-header position-relative">
              <div class="text-center p-4">
                <logo [logoUrlsToTry]="possibleLogoUrls"></logo>
                @if (!alreadyLoggedIn) {
                  <p class="login-title">Please login to access your portal</p>
                  @if (tpoRegistrationLink) {
                    <div class="login-subtitle">
                      New Here? <a class="text-primary fw-bold" href="{{tpoRegistrationLink}}" target="_blank">Create an Account</a>
                    </div>
                  }
                }
              </div>
            </div>
            @if (!alreadyLoggedIn) {
              <div class="card-body p-0">
                <!-- Tab panes -->
                <div class="tab-content">
                  @if (error) {
                    <div class="px-4 pt-2">
                      <div class="alert alert-danger border-0 mb-0" role="alert">
                        <strong>
                          <div>{{error.header}}</div>
                        </strong>
                        {{error.message}}
                      </div>
                    </div>
                  }
                  <form class="form-horizontal auth-form" #loginForm="ngForm" novalidate id="loginForm" name="loginForm">
                    <ngb-carousel #slider [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0"
                      [keyboard]="false"
                      (slide)="currentSlideId = $event.current"
                      (slid)="onCarouselTransitionComplete($event)">
                      <ng-template ngbSlide id="userNameEntry">
                        <div class="login-slide-pane px-4 pt-3 pb-2">
                          @if (loggingIn) {
                            <div class="login-skeleton">
                              <div class="login-skeleton__line login-skeleton__line--title"></div>
                              <div class="login-skeleton__line login-skeleton__line--subtitle"></div>
                              <div class="login-skeleton__line login-skeleton__line--input"></div>
                              <div class="login-skeleton__line login-skeleton__line--helper"></div>
                            </div>
                          } @else {
                            <div class="login-slide-title">Enter Your Username</div>
                            <div class="login-slide-subtitle">We'll use this to find your account.</div>
                            <input type="email" autocomplete="off" class="form-control form-control-lg" name="username" id="login-username"
                              [disabled]="loggingIn" placeholder="Email address" #userName="ngModel" trim
                              [ngClass]="{'is-invalid' : userName && userName.touched && userName.invalid}"
                              (keyup.enter)="onLoginClicked()" [(ngModel)]="loginInfo.username" required email>
                            <div class="invalid-feedback">Please enter a valid email address.</div>
                          }
                        </div>
                      </ng-template>
                        <ng-template ngbSlide id="companySelection">
                          <div class="login-slide-pane px-4 pt-3 pb-2">
                            @if (loggingIn) {
                              <div class="login-skeleton">
                                <div class="login-skeleton__line login-skeleton__line--title"></div>
                                <div class="login-skeleton__line login-skeleton__line--subtitle"></div>
                                <div class="login-skeleton__line login-skeleton__line--input"></div>
                                <div class="login-skeleton__line login-skeleton__line--helper"></div>
                              </div>
                            } @else {
                              <div class="login-slide-title">Select Your Company</div>
                              <div class="login-slide-subtitle">Your account is linked to multiple companies. Choose one to continue.</div>
                              <!-- form= names a form that intentionally doesn't exist, detaching this select from loginForm in
                                   the DOM only (ngModel still binds through NgForm): with it inside the form, Chrome stops
                                   offering saved logins on the username field. -->
                              <select class="form-select form-select-lg" name="company" id="login-company" form="loginCompanyForm"
                                [(ngModel)]="loginInfo.userCompanyGuid"
                                placeholder="Select a Company">
                                <option [ngValue]="null">-- Select One --</option>
                                @for (companies of availableCompanies | groupBy: 'companyGuid'; track companies.key) {
                                  <optgroup label="{{companies.value[0].companyName}}">
                                    @for (company of companies.value; track company.userCompanyGuid; let i = $index) {
                                      <option
                                        value="{{company.userCompanyGuid}}">
                                        {{company.userType}} {{company.externalCompanyId ? (" - " + company.externalCompanyName ) : ""}}
                                      </option>
                                    }
                                  </optgroup>
                                }
                              </select>
                            }
                          </div>
                        </ng-template>
                        <ng-template ngbSlide id="passwordEntry">
                          <div class="login-slide-pane px-4 pt-3 pb-2">
                            @if (loggingIn) {
                              <div class="login-skeleton">
                                <div class="login-skeleton__line login-skeleton__line--title"></div>
                                <div class="login-skeleton__line login-skeleton__line--subtitle"></div>
                                <div class="login-skeleton__line login-skeleton__line--input"></div>
                                <div class="login-skeleton__line login-skeleton__line--helper"></div>
                              </div>
                            } @else {
                              <div [hidden]="!passwordRequired">
                                <div class="login-slide-title">Enter Your Password</div>
                                <div class="login-slide-subtitle">Sign in to continue to your account.</div>
                                <input type="password" autocomplete="off" class="form-control form-control-lg" name="password"
                                  id="login-password" [disabled]="loggingIn" placeholder="Password" (keyup.enter)="onLoginClicked()"
                                  #userPasswordToLogin="ngModel" [ngClass]="{'is-invalid' : userPasswordToLogin && userPasswordToLogin.touched && userPasswordToLogin.invalid}"
                                  [required]="passwordRequired" [(ngModel)]="loginInfo.password" #passwordInput
                                  (keydown)="onKeyDownOnPasswordInput($event)">
                                <div class="invalid-feedback">Please enter your password.</div>
                                @if (secretKeyHitForCompanyOverride) {
                                  <div class="alert alert-warning d-flex align-items-center gap-2 mt-2 mb-2 py-2 px-3" role="alert">
                                    <span class="badge bg-danger text-uppercase">Dev env only</span>
                                    <small class="mb-0">These developer overrides are only available and honored in non-production (DV) environments.</small>
                                  </div>
                                  <input type="number" autocomplete="off" class="form-control mt-2" name="companyIdOverride"
                                    id="companyIdOverride" [disabled]="loggingIn" placeholder="Enter override company Id"
                                    [(ngModel)]="companyIdOverride">
                                  <select class="form-select mt-2" name="debugShortSessionInMinutes" id="debugShortSessionInMinutes"
                                    [disabled]="loggingIn" [(ngModel)]="loginInfo.debugShortSessionInMinutes"
                                    [ngbTooltip]="'DEV ENV ONLY. QA: request a shorter session so the max-session warning/countdown fire fast. Only reduces session length (never extends it) and is only honored in non-production (DV) environments.'"
                                    placement="top">
                                    <option [ngValue]="null">Session length: Normal (server default)</option>
                                    @for (option of debugShortSessionOptions; track option) {
                                      <option [ngValue]="option">Session length: {{ option }} min (DEV ENV ONLY)</option>
                                    }
                                  </select>
                                }
                                <div class="login-helper-row d-flex justify-content-between mt-3" [hidden]="loggingIn">
                                  <a href="javascript:void(0)" (click)="onBackClickedOnPasswordPage()"
                                    class="text-primary fw-bold">Use Different Email</a>
                                  <a href="JavaScript:void(0);" (click)="onForgotPasswordClicked()"
                                    class="text-primary fw-bold">Forgot Password?</a>
                                </div>
                              </div>
                            }
                          </div>
                        </ng-template>
                            <ng-template ngbSlide id="twoFactorCodeEntry">
                              <div class="login-slide-pane px-4 pt-3 pb-2">
                                @if (loggingIn) {
                                  <div class="login-skeleton">
                                    <div class="login-skeleton__line login-skeleton__line--title"></div>
                                    <div class="login-skeleton__line login-skeleton__line--subtitle"></div>
                                    <div class="login-skeleton__line login-skeleton__line--input"></div>
                                    <div class="login-skeleton__line login-skeleton__line--helper"></div>
                                  </div>
                                } @else {
                                <div class="login-slide-title">Verify Your Identity</div>
                                <div class="login-slide-subtitle">
                                  We sent a code to your {{ loginInfo.twoFactorMethod === 'Email' ? 'email' : 'phone' }}.
                                  Enter it below to continue.
                                </div>
                                <input type="text" autocomplete="off" class="form-control form-control-lg" name="twoFactorCode"
                                  id="twoFactorCode" [disabled]="loggingIn" placeholder="Enter Code" #twoFactorCode="ngModel"
                                  [ngClass]="{'is-invalid' : twoFactorCode && twoFactorCode.touched && twoFactorCode.invalid}"
                                  [(ngModel)]="loginInfo.twoFactorCode" (keyup.enter)="onLoginClicked()"
                                  #twoFactorCodeInput>
                                <div class="invalid-feedback">Incorrect code. Please re-enter the code we sent you.</div>
                                <div class="login-helper-row mt-3" [hidden]="loggingIn">
                                  <span class="text-muted">Did not receive a code?</span>
                                  <a class="resend-link text-primary fw-bold ms-1"
                                    data-bs-toggle="popover"
                                    [popover]="templateResendMethod"
                                    placement="right"
                                    data-trigger="click"
                                    [outsideClick]="true"
                                    (onShown)="onShownPopover(p)"
                                    [container]="'body'"
                                    (onHidden)="onHiddenPopover()"
                                    (click)="$event.preventDefault()"
                                    tabindex="0" (keydown.enter)="p.toggle()"
                                    #p="bs-popover">
                                    Resend Code
                                  </a>
                                </div>
                                <!-- Popover template for method selection -->
                                <ng-template #templateResendMethod>
                                  <div class="p-2">
                                    <span class="form-label d-block mb-2 fw-medium">Send via</span>
                                    <div class="ps-2 mb-3 d-flex">
                                      <div class="form-check me-4">
                                        <input class="form-check-input" type="radio" id="resendText" name="resendMethod" value="text" [(ngModel)]="resendMethodType">
                                        <label class="form-check-label" for="resendText">Text</label>
                                      </div>
                                      <div class="form-check">
                                        <input class="form-check-input" type="radio" id="resendEmail" name="resendMethod" value="email" [(ngModel)]="resendMethodType">
                                        <label class="form-check-label" for="resendEmail">Email</label>
                                      </div>
                                    </div>
                                    <button class="btn btn-primary w-100" [disabled]="sendingCode" (click)="onSendCodeClicked(resendMethodType)">
                                      @if (sendingCode) {
                                        <span class="spinner-border spinner-border-sm me-1" style="position: relative; top: 1px" role="status" aria-hidden="true"></span>
                                      }
                                      {{sendingCode ? 'Sending...' : 'Send Code'}}
                                    </button>
                                  </div>
                                </ng-template>
                                }
                              </div>
                            </ng-template>
                              <ng-template ngbSlide id="mfaSetup">
                                <div class="login-slide-pane px-4 pt-3 pb-2">
                                  <form class="form-horizontal auth-form" #mfaSetupForm="ngForm" novalidate id="mfaSetupForm"
                                    name="mfaSetupForm">
                                    <div class="login-slide-title">You need to setup MFA on your account</div>
                                    @if (!needToConfirmPhone) {
                                      <div class="login-slide-subtitle">Add a phone number to secure your account.</div>
                                      <div class="mt-2 d-flex">
                                        <div class="flex-grow-1">
                                          <phone-input name="phoneNumber" [(ngModel)]="setting.phone"
                                            [(areaCode)]="setting.areaCode" [appendTo]="'body'"
                                            inputClass="form-control form-control-lg"></phone-input>
                                        </div>
                                      </div>
                                    }
                                    @if (needToConfirmPhone) {
                                      <div class="login-slide-subtitle">Enter the verification code we sent you.</div>
                                      <input type="text" autocomplete="off" class="form-control form-control-lg" name="verificationCode"
                                        id="verificationCode" [disabled]="loggingIn" placeholder="Enter Code" #verificationCodeValue="ngModel"
                                        [ngClass]="{'is-invalid' : verificationCodeValue && verificationCodeValue.touched && verificationCodeValue.invalid}"
                                        [(ngModel)]="verificationCode" (keyup.enter)="onLoginClicked()" [appAutofocus]="true" #verificationCodeInput>
                                      <div class="invalid-feedback">Incorrect code. Please re-enter the code we sent you.</div>
                                    }
                                  </form>
                                </div>
                                  </ng-template>
                                </ngb-carousel>
                                <!-- Action bar - shared by every step (including MFA-setup) so all carousel
                                     panes stay a uniform height; the card never resizes or flashes between
                                     slides, and ngb's slide animation has no height delta to resolve. -->
                                <div class="login-action-bar px-4 pb-4">
                                    @if (currentSlideId === 'companySelection') {
                                      @if (!loggingIn) {
                                        <div class="d-flex w-100">
                                          <button type="button" class="btn btn-lg btn-soft-secondary"
                                                  (click)="onCancelLoginClicked()">Cancel</button>
                                          <button type="button" class="btn btn-lg btn-primary ms-auto"
                                                  name="letsGoBtn" id="login-letsgo-btn"
                                                  [disabled]="!loginInfo.userCompanyGuid"
                                                  (click)="onLetsGoClickedOnCompanySelectionPage()">Lets go!</button>
                                        </div>
                                      }
                                      @if (loggingIn) {
                                        <button class="btn btn-lg btn-primary w-100" type="button" disabled="">
                                          <span class="indicator-label">
                                            {{companyName ? 'Going to ' + companyName + '...' : 'Please wait...'}}
                                          </span>
                                          <span class="spinner-border spinner-border-sm align-middle ms-2" role="status" aria-hidden="true"></span>
                                        </button>
                                      }
                                    } @else if (currentSlideId === 'twoFactorCodeEntry') {
                                      @if (!loggingIn) {
                                        <div class="d-flex w-100">
                                          <button type="button" class="btn btn-lg btn-soft-secondary"
                                                  (click)="onCancelLoginClicked()">Cancel</button>
                                          <button type="button" class="btn btn-lg btn-primary ms-auto"
                                                  [disabled]="!loginInfo.twoFactorCode"
                                                  (click)="onLoginClicked()">Verify</button>
                                        </div>
                                      }
                                      @if (loggingIn) {
                                        <button class="btn btn-lg btn-primary w-100" type="button" disabled="">
                                          <span class="indicator-label">Please wait...</span>
                                          <span class="spinner-border spinner-border-sm align-middle ms-2" role="status" aria-hidden="true"></span>
                                        </button>
                                      }
                                    } @else if (currentSlideId === 'mfaSetup') {
                                      @if (!loggingIn && !needToConfirmPhone) {
                                        <div class="d-flex w-100">
                                          <button type="button" class="btn btn-lg btn-soft-secondary"
                                                  (click)="onCancelLoginClicked()">Cancel</button>
                                          <button type="button" class="btn btn-lg btn-primary ms-auto"
                                                  [disabled]="!canSaveMfaPhone"
                                                  (click)="onSaveNumberClicked()">Save Number</button>
                                        </div>
                                      }
                                      @if (!loggingIn && needToConfirmPhone) {
                                        <div class="d-flex w-100 align-items-center">
                                          <button type="button" class="btn btn-lg btn-soft-secondary"
                                                  (click)="onCancelLoginClicked()">Cancel</button>
                                          <a href="javascript:void(0)" class="text-primary fw-bold mx-auto"
                                             (click)="onChangeNumberClicked()">Change Number</a>
                                          <button type="button" class="btn btn-lg btn-primary"
                                                  [disabled]="!verificationCode"
                                                  (click)="onConfirmPhoneClicked()">Verify</button>
                                        </div>
                                      }
                                      @if (loggingIn) {
                                        <button class="btn btn-lg btn-primary w-100" type="button" disabled="">
                                          <span class="indicator-label">Please wait...</span>
                                          <span class="spinner-border spinner-border-sm align-middle ms-2" role="status" aria-hidden="true"></span>
                                        </button>
                                      }
                                    } @else {
                                      @if (!loggingIn) {
                                        <button class="btn btn-lg btn-primary w-100" type="button" name="loginBtn" id="login-login-btn"
                                          (click)="onLoginClicked()">
                                          <span class="indicator-label">Continue</span>
                                        </button>
                                      }
                                      @if (loggingIn) {
                                        <button class="btn btn-lg btn-primary w-100" type="button" disabled="">
                                          <span class="indicator-label">
                                            {{companyName ? 'Going to ' + companyName + '...' : 'Please wait...'}}
                                          </span>
                                          <span class="spinner-border spinner-border-sm align-middle ms-2" role="status" aria-hidden="true"></span>
                                        </button>
                                      }
                                    }
                                </div>
                              </form>
                            </div>
                          </div>
                        }
                        @if (alreadyLoggedIn) {
                          <div class="card-body text-center" style="padding: 1.75rem 2rem;">
                            <div class="tpo-loader-spin" style="margin-bottom: 1rem;">
                              <i-lucide name="loader-2" [size]="32" [strokeWidth]="2"
                                style="color: #3182CE;">
                              </i-lucide>
                            </div>
                            <h5 style="font-size: 1.125rem; font-weight: 600; color: #1A202C; margin: 0 0 0.5rem;">
                              Welcome back
                            </h5>
                            <p style="font-size: 0.875rem; color: #718096; margin: 0;">
                              Verifying login and redirecting to dashboard...
                            </p>
                          </div>
                        }
                        <!--end card-body-->
                        <div class="card-body bg-light-alt text-center login-footer">
                          <span class="text-muted d-none d-sm-inline-block">Lodasoft {{currentYear}}</span>
                        </div>
                      </div>
                      <!--end card-->
                    </div>
                    <!--end col-->
                  </div>
                  <!--end row-->

                  <!--end row-->
                </div>
                <!--end container-->
                <!-- End Log In page -->
              </div>
